/** CASE TYPE 10 — Attorney General / AGD Internal: Select/Enter <Field name> */
export function agSelectPlaceholder(fieldName: string): string {
  return `Select ${fieldName}`;
}

export function agEnterPlaceholder(fieldName: string): string {
  return `Enter ${fieldName}`;
}
